import axios from "axios";

const moduleTransferInventory = {
  namespaced: true,
  state: {
    transferList: [],
    destinationBranchList: [],
    transferDetail: null,
  },
  mutations: {
    setTransferList(state, data) {
      state.transferList = data;
    },
    setDestinationBranchList(state, data) {
      state.destinationBranchList = data;
    },
    setTransferDetail(state, data) {
      state.transferDetail = data;
    },
  },
  actions: {
    async fetchTransferList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/stockTransfer/${clinicUrl}/${branchUrl}`
        );

        const data = res.data.data;
        const transferOut = data.transferOut.map(j => ({
          transferId: j.id,
          transferNo: j.transferNo,
          transferDestinationBranchName: j.toBranch?.name ?? "",
          transferStatus: j.status,
          transferCreationDate: j.creationDt,
        }));

        const transferIn = data.transferIn.map(j => ({
          transferId: j.id,
          transferNo: j.transferNo,
          transferSourceBranchName: j.fromBranch?.name ?? "",
          transferStatus: j.status,
          transferCreationDate: j.creationDt,
        }));

        const payload = {
          transferOut,
          transferIn,
        };

        commit("setTransferList", payload);
      } catch (err) {
        console.error("fetchTransferList failed", err);
        throw err;
      }
    },
    async fetchDestinationBranchList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/stockTransfer/dropdown/${clinicUrl}/${branchUrl}`
        );
        const items = res.data.data.map(i => ({
          branchId: i.id,
          branchName: i.name,
        }));

        commit("setDestinationBranchList", items);
        return items;
      } catch (err) {
        console.error("fetchDestinationBranchList failed", err);
        throw err;
      }
    },
    deleteTransferOutItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/stockTransfer/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    createTransferOut({ commit, getters }, payload) {
      return axios
        .post(
          `/api/stockTransfer/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustTransferOutData,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    getTransferDetailById({ commit, getters }, payload) {
      return axios
        .get(
          `/api/stockTransfer/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`
        )
        .then(res => {
          const data = res.data.data;
          const item = {
            transferId: data.id,
            transferNo: data.transferNo,
            transferActionDate: data.modifyDt,
            transferSourceBranchName: data.fromBranch?.name ?? "",
            transferDestinationBranchName: data.toBranch?.name ?? "",
            transferProductItems: data.stockTransferProducts.map(j => ({
              productCode: j.product.no,
              productNameMain: j.product.description,
              productQty: j.qtyUom,
              productUnit: j.uom.description,
            })),
          };
          commit("setTransferDetail", item);
          return item;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    updateTransferInStatusItem({ commit, getters }, payload) {
      return axios
        .patch(
          `/api/stockTransfer/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.actionTransfer,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getTransferList: state => {
      return state.transferList;
    },
    getDestinationBranchList: state => {
      return state.destinationBranchList;
    },
    getTransferDetail: state => {
      return state.transferDetail;
    },
  },
};

export default moduleTransferInventory;
